import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useCms } from '../context/CmsContext';
import { AnnouncementText } from '../lib/api';
import AnnouncementModal from './AnnouncementModal';
import './AnnouncementBar.css';

const CLOSED_KEY = 'msl_ann_closed';

// 后端不可用时，回退到内置 i18n 公告文案（当前语言）
function fallbackAnnouncement(t: any): AnnouncementText {
  return {
    bar: t.announcement.bar,
    modalTitle: t.announcement.modalTitle,
    sections: [
      { title: t.announcement.section1Title, content: t.announcement.section1Content },
      { title: t.announcement.section2Title, content: t.announcement.section2Content },
      { title: t.announcement.section3Title, content: t.announcement.section3Content },
    ],
  };
}

const AnnouncementBar: React.FC = () => {
  const { t, currentLang } = useLanguage();
  const { announcements } = useCms();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const ann = announcements.find((a) => a.enabled) ?? null;
  const fallback = ann ? null : fallbackAnnouncement(t);
  const display =
    ann && (ann.text[currentLang as 'zh' | 'en'] || ann.text.zh)
      ? ann.text[currentLang as 'zh' | 'en'] || ann.text.zh
      : null;
  const barText = display?.bar ?? fallback?.bar ?? '';
  const annId = ann ? ann.id : 0;

  // 关闭公告持久化（刷新后不再出现）
  const [isVisible, setIsVisible] = useState(() => {
    return localStorage.getItem(CLOSED_KEY) !== String(annId);
  });

  if (!isVisible) return null;

  return (
    <>
      <div className="announcement-bar">
        <div className="announcement-content">
          <span className="announcement-icon">📢</span>
          <span className="announcement-text">{barText}</span>
          <button className="announcement-btn" onClick={() => setIsModalOpen(true)}>
            {t.announcement.readMore}
          </button>
        </div>
        <button
          className="announcement-close"
          onClick={() => {
            try {
              localStorage.setItem(CLOSED_KEY, String(annId));
            } catch (e) {}
            setIsVisible(false);
          }}
        >
          ✕
        </button>
      </div>
      <AnnouncementModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        announcement={display}
        fallbackAnn={fallback ?? undefined}
      />
    </>
  );
};

export default AnnouncementBar;